import styles from '../../assets/styles/Components/ReceiptCheckBox.module.scss';

const ReceiptCheckBox = ({
	title = '',
	value = '',
	id,
	onChange = e => {},
	name,
	checked = false,
	disabled = false,
	...props
}) => {
	return (
		<label htmlFor={id} className={styles.rcb} {...props}>
			<input
				{...props}
				type="checkbox"
				name={name}
				id={id}
				onChange={onChange}
				checked={checked ? 'checked' : ''}
				className={styles.rcb__input}
			/>
			<span className={styles.rcb__check}></span>
			{title}
		</label>
	);
};

export default ReceiptCheckBox;
